import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { RouterModule } from '@angular/router';

import { UserService, SigninService, PanierHeaderComponent, CartService, CommandeService } from '../shared';
import { ProfileComponent } from './_profile/profile.component';
import { SignInComponent } from './_sign-in/sign-in.component';
import { LogInComponent } from './_log-in/log-in.component';
import { CartComponent } from './_cart/cart.component';
import { ValidationComponent } from './_validation/validation.component';
import { AddressComponent } from './_address/address.component';
import { PurchasesComponent } from './_purchases/purchases.component';
import { RessourcesComponent } from './_ressources/ressources.component';
import { PaymentComponent } from './_payment/payment.component';
import { ConfirmComponent } from './_confirm/confirm.component';

@NgModule({
  imports: [ CommonModule, ReCaptchaModule, FormsModule, ReactiveFormsModule, RouterModule ],
  declarations: [
  	ProfileComponent,
  	SignInComponent,
  	LogInComponent,
  	CartComponent,
  	ValidationComponent,
    AddressComponent,
    PurchasesComponent,
    RessourcesComponent,
    PaymentComponent,
    ConfirmComponent,
  	PanierHeaderComponent,
  ],
  providers: [ UserService, SigninService, CartService, CommandeService ]
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/user/user.module.ts